import { render } from "./CenterWrapper.vue?vue&type=template&id=54b00c72&scoped=true"
const script = {}

import "./CenterWrapper.vue?vue&type=style&index=0&id=54b00c72&lang=postcss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b00c72"]])

export default __exports__